function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_3866",
  "data-name": "Rectangle 3866",
  width: 30,
  height: 30,
  rx: 15,
  fill: "#2fcc71"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_2739",
  "data-name": "Path 2739",
  d: "M17.263,5.226a.792.792,0,0,0-1.12,0L7.234,14.1,3.848,10.722a.8.8,0,0,0-1.12,0,.785.785,0,0,0,0,1.115l3.945,3.925a.792.792,0,0,0,1.12,0l9.469-9.421a.782.782,0,0,0,0-1.115Z",
  transform: "translate(4.602 4.867)",
  fill: "#fff"
});

function SvgSucess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "success",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSucess);
export default __webpack_public_path__ + "static/media/sucess.d4630209.svg";
export { ForwardRef as ReactComponent };